import { Entity } from "@thewebops/admin-panel";

export default (authConfig) =>
  new Entity({
    title: { en: "Login to your account", ar: "تسجيل الدخول للحساب" },
    subTitle: {
      en: `Enter the credentials associated with your ${authConfig.displayName} account.`,
      ar: `${authConfig.displayName}ادخل بيانات الحساب التابعة ل`,
    },
    logoTitle: "Nutivate",
    path: "/login",
    submitButtonText: { en: "Login", ar: "الدخول" },
    action: "create",
    fields: [
      {
        label: { en: "Email", ar: "البريد الإلكتروني" },
        required: true,
        type: "email",
        identifier: "email",
        accessor: "email",
      },
      {
        label: { en: "Password", ar: "كلمة المرور" },
        required: true,
        type: "password",
        identifier: "password",
        accessor: "email",
      },
    ],
    requestConfig: {
      url: `/${authConfig.serverPluralName}/sign_in`,
      method: "post",
      saveToLocalStorage: true,
      useFormData: true,
    },
  });
